import {http, onSuccess, onFail} from './http';

export const getEpisodeTags = (episodeId) => {
    return http.get(`/api/cp/event/stream/episode/${episodeId}/tag`)
        .then(onSuccess, onFail);
}

export const addEpisodeTag = (episodeId, tagId, payload) => {
    return http.post(`/api/cp/event/stream/episode/${episodeId}/tag/${tagId}`, payload)
        .then(onSuccess, onFail);
}

export const removeEpisodeTag = (episodeId, tagId) => {
    return http.delete(`/api/cp/event/stream/episode/${episodeId}/tag/${tagId}`)
        .then(onSuccess, onFail);
}

export const updateEpisodeTagsOrder = (episodeId, payload) => {
    return http.post(`/api/cp/event/stream/episode/${episodeId}/tag-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
}
